<template>
  <b-navbar toggleable="md" id="header" sticky class="text-center" :class="!showCollapse ? 'blue-banner' : ''">
    <router-link id="logo" :to="{ name: 'Home' }" class="navbar-brand">
      <img src="/img/logos/logo_white.png" id="logo" v-if="!showCollapse"/>
      <img src="/img/logos/logo_color.png" id="logo" v-else/>
    </router-link>
    <b-navbar-toggle target="nav-collapse" class="header-navbar-toggle">
      <template #default="{ expanded }">
        <b-icon v-if="expanded" icon="x" scale="1.2"></b-icon>
        <b-icon v-else icon="list" scale="1.2"></b-icon>
      </template>
    </b-navbar-toggle>
    
    <b-collapse id="nav-collapse" is-nav v-if="showCollapse">
      <div id="nav" v-if="!currentUser"></div>
      <b-navbar-nav>
        <router-link :to="{ name: 'About' }" class="nav-item nav-item-first">
          ABOUT
        </router-link>
        <router-link :to="{ name: 'HowItWorks' }" class="nav-item">
          HOW IT WORKS
        </router-link>
        <router-link :to="{ name: 'Organizations' }" class="nav-item">
          FOR ORGANIZATIONS
        </router-link>
        <a href="https://torchmetricsblog.wordpress.com/" target="_blank" class="nav-item">BLOG</a>
      </b-navbar-nav>

      <!-- Right aligned nav items -->
      <b-navbar-nav class="ml-auto">
        <router-link :to="{ name: 'GetStarted' }" id="signup">
          SIGN UP
        </router-link>
        <router-link :to="{ name: 'LogIn' }" id="login"> LOG IN </router-link>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "Header",
  props: ['showCollapse'],
  computed: {
    ...mapState(["currentUser"]),
  },
  methods: {
    ...mapActions(["LOG_OUT"]),
  },
  watch: {
    currentUser() {
      if (!this.currentUser) {
        this.$router.push({ name: "Home" });
      }
    },
  },
};
</script>
<style lang="less" >
@import "../../assets/common/Header.less";
</style>